import { useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { EmcVendorForm, EmcVendorFormType } from './EmcVendorForm'
import { createEmcVendor } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useNavigate } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Emc Vendors',
    path: '/system/emc-vendors'
  },
  {
    label: 'Add',
    isCurrentPage: true
  }
]

export const AddEmcVendor = () => {
  const navigate = useNavigate()
  const { createToast } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleAdd = async (form) => {
    setIsSubmitting(true)

    try {
      await createEmcVendor({
        name: form.name,
        contact: form.contact,
        email: form.email,
        phone: form.phone,
        address: form.address,
        city: form.city,
        state: form.state,
        zip: form.zip
      })
      createToast('success', 'Emc vendor created')
      navigate('/system/emc-vendors')
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Add Emc Vendor</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <EmcVendorForm
              type={EmcVendorFormType.Add}
              onSubmit={handleAdd}
              isSubmitting={isSubmitting}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
